import { useLayoutEffect } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, PageViewTrackingEvent, TrackingEventName, TrackingPage, TrackingView } from "./tracking";

interface UseTrackPageViewFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly view: TrackingView;
  readonly tradename: Tradename;
}

interface UseTrackPageViewFunction {
  (args: UseTrackPageViewFunctionArgs): void;
}

const useTrackPageView: UseTrackPageViewFunction = ({ page, country, segment, tradename, userId, view }) => {
  const emitUserEvent = useEmitUserEvent<PageViewTrackingEvent>();

  useLayoutEffect(() => {
    emitUserEvent({
      event: TrackingEventName.PAGE_VIEW,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_${PROJECT}-${page}`,
      store: country,
      segment,
      tradename,
      userId,
      userUuid: userId,
      category: PROJECT,
      view,
    });
  }, [country, emitUserEvent, page, segment, tradename, userId, view]);
};

export { useTrackPageView };
